export enum GrChatStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}
